export const TOPHANDWERK_MIT_PFLEGEVERTAG = 4;
export const NO_OLD_PACKAGE_PLAN = 1;
